// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__x80Ot","Linux":"Home_Linux__IpNCK","T":"Home_T__DzcFe"};